import { render, staticRenderFns } from "./statistic-chart.vue?vue&type=template&id=f17e3268&scoped=true&"
import script from "./statistic-chart.vue?vue&type=script&lang=js&"
export * from "./statistic-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17e3268",
  null
  
)

export default component.exports